// import React from 'react';
// import { Card, Row, Col, Typography, Divider } from 'antd';
// import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
// import Header from '../components/Header';

// const { Title, Paragraph, Text } = Typography;

// const ContactUs = () => {
//   return (

//     <div className="about-ksm-page">
//       <Header />
//       <div style={{ padding: '40px 20px', background: '#FEF9F2', minHeight: '100vh' }}>
//         <div style={{ maxWidth: 1000, margin: '0 auto' }}>
//           {/* Header */}
//           <div style={{ textAlign: 'center', marginBottom: 20, marginTop: 90 }}>
//             <Title level={2} className="content-title">
//               Contact Us
//             </Title>

//           </div>

//           {/* Contact Information */}
//           <Row gutter={[32, 32]} style={{ marginBottom: 60 }}>
//             {/* Phone */}
//             <Col xs={24} md={8}>
//               <Card
//                 bordered
//                 style={{
//                   textAlign: 'center',
//                   height: '100%',
//                   borderColor: '#d9d9d9',
//                   borderRadius: 8,
//                   transition: 'all 0.3s ease'
//                 }}
//                 bodyStyle={{ padding: 32 }}
//                 hoverable
//               >
//                 <div
//                   style={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 60,
//                     height: 60,
//                     borderRadius: '50%',
//                     backgroundColor: '#e6f7ff',
//                     marginBottom: 24
//                   }}
//                 >
//                   <PhoneOutlined style={{ fontSize: 28, color: '#1890ff' }} />
//                 </div>
//                 <Title level={4} style={{ marginBottom: 16, fontWeight: 500 }}>
//                   Call Us
//                 </Title>
//                 <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
//                   <a
//                     href="tel:+918281236371"
//                     style={{
//                       color: '#262626',
//                       textDecoration: 'none',
//                       display: 'block',
//                       fontSize: '16px'
//                     }}
//                     onMouseEnter={(e) => e.target.style.color = '#1890ff'}
//                     onMouseLeave={(e) => e.target.style.color = '#262626'}
//                   >
//                     +91 8281236371
//                   </a>
//                   <Text style={{ color: '#bfbfbf' }}>/</Text>
//                   <a
//                     href="tel:+919656660444"
//                     style={{
//                       color: '#262626',
//                       textDecoration: 'none',
//                       display: 'block',
//                       fontSize: '16px'
//                     }}
//                     onMouseEnter={(e) => e.target.style.color = '#1890ff'}
//                     onMouseLeave={(e) => e.target.style.color = '#262626'}
//                   >
//                     +91 9656660444
//                   </a>
//                 </div>
//               </Card>
//             </Col>

//             {/* Email */}
//             <Col xs={24} md={8}>
//               <Card
//                 bordered
//                 style={{
//                   textAlign: 'center',
//                   height: '100%',
//                   borderColor: '#d9d9d9',
//                   borderRadius: 8,
//                   transition: 'all 0.3s ease'
//                 }}
//                 bodyStyle={{ padding: 32 }}
//                 hoverable
//               >
//                 <div
//                   style={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 60,
//                     height: 60,
//                     borderRadius: '50%',
//                     backgroundColor: '#e6f7ff',
//                     marginBottom: 24
//                   }}
//                 >
//                   <MailOutlined style={{ fontSize: 28, color: '#1890ff' }} />
//                 </div>
//                 <Title level={4} style={{ marginBottom: 16, fontWeight: 500 }}>
//                   Email Us
//                 </Title>
//                 <a
//                   href="mailto:contact@svmmkerala.org"
//                   style={{
//                     color: '#262626',
//                     textDecoration: 'none',
//                     fontSize: '16px'
//                   }}
//                   onMouseEnter={(e) => e.target.style.color = '#1890ff'}
//                   onMouseLeave={(e) => e.target.style.color = '#262626'}
//                 >
//                   contact@svmmkerala.org
//                 </a>
//               </Card>
//             </Col>

//             {/* Location */}
//             <Col xs={24} md={8}>
//               <Card
//                 bordered
//                 style={{
//                   textAlign: 'center',
//                   height: '100%',
//                   borderColor: '#d9d9d9',
//                   borderRadius: 8,
//                   transition: 'all 0.3s ease'
//                 }}
//                 bodyStyle={{ padding: 32 }}
//                 hoverable
//               >
//                 <div
//                   style={{
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     width: 60,
//                     height: 60,
//                     borderRadius: '50%',
//                     backgroundColor: '#e6f7ff',
//                     marginBottom: 24
//                   }}
//                 >
//                   <EnvironmentOutlined style={{ fontSize: 28, color: '#1890ff' }} />
//                 </div>
//                 <Title level={4} style={{ marginBottom: 16, fontWeight: 500 }}>
//                   Our Location
//                 </Title>
//                 <Paragraph
//                   type="secondary"
//                   style={{ lineHeight: 1.6, margin: 0 }}
//                 >
//                   Find us at our office location
//                 </Paragraph>
//               </Card>
//             </Col>
//           </Row>

//           {/* Map Section */}
//           <Card
//             bordered
//             style={{
//               borderRadius: 8,
//               borderColor: '#d9d9d9',
//               overflow: 'hidden'
//             }}
//           >
//             <div style={{ padding: '14px', borderBottom: '1px solid #f0f0f0' }}>
//               <Title level={4} style={{ margin: 0, fontWeight: 500 }}>
//                 Visit Our Office
//               </Title>
//             </div>

//             <div style={{ padding: '10px' }}>
//               <iframe
//                 src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.8839582476147!2d76.2743!3d9.9313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwNTUnNTIuNyJOIDc2wrAxNicyNy41IkU!5e0!3m2!1sen!2sin!4v1234567890"
//                 width="100%"
//                 height="300"
//                 style={{
//                   border: 0,
//                   borderRadius: 8,
//                   display: 'block'
//                 }}
//                 allowFullScreen=""
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//                 title="SVMM Kerala Location"
//               />
//             </div>

//             <Divider style={{ margin: 0 }} />

//             <div style={{
//               padding: '24px',
//               textAlign: 'center',
//               backgroundColor: '#fafafa'
//             }}>
//               <Text type="secondary">
//                 Use Ctrl + scroll to zoom the map • Click and drag to navigate
//               </Text>
//             </div>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ContactUs;




import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Typography, Divider, Spin } from 'antd';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import Header from '../components/Header';

const { Title, Paragraph, Text } = Typography;

const ContactUs = () => {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContactData();
  }, []);

  const fetchContactData = async () => {
    try {
      setLoading(true);
      const response = await fetch('/api/termsconditions'); // Your API endpoint
      const data = await response.json();
      //console.log('Contact data:', data.contact);
      if (data.contact) {
        setContactData(data.contact);
      }
    } catch (err) {
      console.error('Error fetching contact data:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="about-ksm-page">
        <Header />
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
          <Spin size="large" />
        </div>
      </div>
    );
  }

  return (
    <div className="about-ksm-page">
      <Header />
      <div style={{ padding: '40px 20px', background: '#FEF9F2', minHeight: '100vh' }}>
        <div style={{ maxWidth: 1000, margin: '0 auto' }}>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: 20, marginTop: 90 }}>
            <Title level={2} className="content-title">
              {contactData?.title || 'Contact Us'}
            </Title>
            {contactData?.description && (
              <Paragraph
                style={{
                  fontSize: '16px',
                  color: '#666',
                  maxWidth: 600,
                  margin: '0 auto',
                  lineHeight: 1.6
                }}
              >
                {contactData.description}
              </Paragraph>
            )}
          </div>

          {/* Contact Information */}
          <Row gutter={[32, 32]} style={{ marginBottom: 60 }}>
            {/* Phone */}
            {(contactData?.phone1 || contactData?.phone2) && (
              <Col xs={24} md={8}>
                <Card
                  bordered
                  style={{
                    textAlign: 'center',
                    height: '100%',
                    borderColor: '#d9d9d9',
                    borderRadius: 8,
                    transition: 'all 0.3s ease'
                  }}
                  bodyStyle={{ padding: 32 }}
                  hoverable
                >
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      backgroundColor: '#e6f7ff',
                      marginBottom: 24
                    }}
                  >
                    <PhoneOutlined style={{ fontSize: 28, color: '#1890ff' }} />
                  </div>
                  <Title level={4} style={{ marginBottom: 16, fontWeight: 500 }}>
                    Call Us
                  </Title>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {contactData.phone1 && (
                      <a
                        href={`tel:${contactData.phone1}`}
                        style={{
                          color: '#262626',
                          textDecoration: 'none',
                          display: 'block',
                          fontSize: '16px'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#1890ff'}
                        onMouseLeave={(e) => e.target.style.color = '#262626'}
                      >
                        {contactData.phone1}
                      </a>
                    )}
                    {/* {contactData.phone1 && contactData.phone2 && (
                      <Text style={{ color: '#bfbfbf' }}>/</Text>
                    )} */}
                    {contactData.phone2 && (
                      <a
                        href={`tel:${contactData.phone2}`}
                        style={{
                          color: '#262626',
                          textDecoration: 'none',
                          display: 'block',
                          fontSize: '16px'
                        }}
                        onMouseEnter={(e) => e.target.style.color = '#1890ff'}
                        onMouseLeave={(e) => e.target.style.color = '#262626'}
                      >
                        {contactData.phone2}
                      </a>
                    )}
                  </div>
                </Card>
              </Col>
            )}

            {/* Email */}
            {contactData?.email && (
              <Col xs={24} md={8}>
                <Card
                  bordered
                  style={{
                    textAlign: 'center',
                    height: '100%',
                    borderColor: '#d9d9d9',
                    borderRadius: 8,
                    transition: 'all 0.3s ease'
                  }}
                  bodyStyle={{ padding: 32 }}
                  hoverable
                >
                  <div
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      backgroundColor: '#e6f7ff',
                      marginBottom: 24
                    }}
                  >
                    <MailOutlined style={{ fontSize: 28, color: '#1890ff' }} />
                  </div>
                  <Title level={4} style={{ marginBottom: 16, fontWeight: 500 }}>
                    Email Us
                  </Title>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <a
                      href={`mailto:${contactData.email}`}
                      style={{
                        color: '#262626',
                        textDecoration: 'none',
                        fontSize: '16px'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#1890ff'}
                      onMouseLeave={(e) => e.target.style.color = '#262626'}
                    >
                      {contactData.email}
                    </a>
                    <a
                      href={`mailto:${contactData.email2}`}
                      style={{
                        color: '#262626',
                        textDecoration: 'none',
                        fontSize: '16px'
                      }}
                      onMouseEnter={(e) => e.target.style.color = '#1890ff'}
                      onMouseLeave={(e) => e.target.style.color = '#262626'}
                    >
                      {contactData.email2}
                    </a>
                  </div>
                </Card>
              </Col>
            )}

            {/* Location */}
            <Col xs={24} md={8}>
              <Card
                bordered
                style={{
                  textAlign: 'center',
                  height: '100%',
                  borderColor: '#d9d9d9',
                  borderRadius: 8,
                  transition: 'all 0.3s ease'
                }}
                bodyStyle={{ padding: 32 }}
                hoverable
              >
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    backgroundColor: '#e6f7ff',
                    marginBottom: 24
                  }}
                >
                  <EnvironmentOutlined style={{ fontSize: 28, color: '#1890ff' }} />
                </div>
                <Title level={4} style={{ marginBottom: 16, fontWeight: 500 }}>
                  Our Location
                </Title>
                <Paragraph
                  type="secondary"
                  style={{ lineHeight: 1.6, margin: 0 }}
                >
                  {contactData?.address || 'Find us at our office location'}
                </Paragraph>
              </Card>
            </Col>
          </Row>

          {/* Map Section */}
          <Card
            bordered
            style={{
              borderRadius: 8,
              borderColor: '#d9d9d9',
              overflow: 'hidden'
            }}
          >


            <div style={{ padding: '5px' }}>
              <iframe
                src={contactData?.mapUrl || 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.8839582476147!2d76.2743!3d9.9313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOcKwNTUnNTIuNyJOIDc2wrAxNicyNy41IkU!5e0!3m2!1sen!2sin!4v1234567890'}
                width="100%"
                height="300"
                style={{
                  border: 0,
                  borderRadius: 8,
                  display: 'block'
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SVMM Kerala Location"
              />
            </div>

            <Divider style={{ margin: 0 }} />

            <div style={{
              padding: '24px',
              textAlign: 'center',
              backgroundColor: '#fafafa'
            }}>
              <Text type="secondary">
                Use Ctrl + scroll to zoom the map • Click and drag to navigate
              </Text>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;